/*(function($) {

	'use strict';

	var init = function() {

        var topMin = parseInt($('.sticky').css('top'), 10);
        var topMax = $(window).height() - $('footer').height() - 92 - topMin;
        var screenMax = $(document).height() - $(window).height();

		stickyScroll(topMin, topMax, screenMax);
        
    };
    
    var stickyScroll = function(topMin, topMax, screenMax) {
        $(window).scroll(function() {
            
            var factor = (screenMax - $(document).scrollTop()) / screenMax;
            $('.sticky').css('top', (topMin + (topMax - (topMax * factor))));
        });
    }

	$(document).ready(function() {
		init();
	});

})(jQuery);*/